import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  light?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  align = 'center',
  light = false
}: SectionHeadingProps) {
  return <div className={`mb-8 md:mb-12 ${align === 'center' ? 'text-center' : 'text-left'}`} data-id="element-332">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className={`font-serif text-2xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4 ${light ? 'text-offwhite' : 'text-terracotta'}`} data-id="element-333">
        {title}
      </motion.h2>
      {subtitle && <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.1
    }} className={`font-sans text-base md:text-xl max-w-3xl ${align === 'center' ? 'mx-auto' : ''} ${light ? 'text-offwhite/80' : 'text-brown/80'}`} data-id="element-334">
          {subtitle}
        </motion.p>}
    </div>;
}